import { API_BASE_URL } from "../config/apiBaseUrl.js";

const API_BASE = API_BASE_URL;

export function resolvePublicImageUrl(src) {
  if (!src || typeof src !== "string") {
    return null;
  }

  const trimmed = src.trim();

  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }

  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }

  return trimmed.startsWith("/") ? `${API_BASE}${trimmed}` : `${API_BASE}/${trimmed}`;
}

export function buildProxiedImageUrl(originalUrl) {
  if (!originalUrl || typeof originalUrl !== "string") {
    return null;
  }

  const trimmed = originalUrl.trim();
  if (!trimmed.startsWith("http://") && !trimmed.startsWith("https://")) {
    return null;
  }

  return `${API_BASE}/api/media/proxy-image?url=${encodeURIComponent(trimmed)}`;
}
